<script>
  import { ignore, getRandomInt } from "./tools";
  export let data,
    label = "",
    description = "",
    onChange = ignore,
    clz = "mt-15 f-left col20";
  const id = "cbx_" + getRandomInt();

  function change(e) {
    onChange(e.target.checked);
  }
</script>

<div class="checkbox-wrapper {clz}">
  <input id={id} class="css-checkbox" type="checkbox" bind:checked={data} on:change={change} />
  <label for={id} class="css-label">
    {label}
    {#if description}
      <span>{description}</span>
    {/if}
  </label>
</div>
